import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Inquiries from "../pages/inquiries";
import Reorder from "../pages/ReorderModule";
import Login from "../pages/LoginPage";
import ShipDetails from "../pages/shipDetails";
import NotFound from "../pages/notFound";
import Loader from "../components/loader";
import CancelOrder from "../pages/cancelOrder";
import OrderUpdate from "../pages/orderUpdate";
import BirthdaySale from "../pages/BirthdaySale";
import Winners from "../pages/winner";
import CouponCode from "../pages/couponCode.js";
import CouponCardTable from "../pages/couponCard.jsx";
import CouponCard from "../pages/couponCard.jsx";
import ExpertWorkShop from "../pages/expertWorkShop.jsx";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      Cookies.remove("token");
      localStorage.removeItem("userData");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

const PrivateRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();
  const verifyUser = async (token) => {
    try {
      const response = await axios.get(
        "https://api.iplanet.one/casaformdata/verifyuser",
        {
          headers: { Authorization: token },
        },
      );
      if (response.data?.success === true) {
        localStorage.setItem("userData", JSON.stringify(response.data.user));
        setIsAuthenticated(true);
      } else {
        throw new Error("Verification failed");
      }
    } catch (err) {
      console.error("Verify failed:", err);
      Cookies.remove("token");
      localStorage.removeItem("userData");
      setIsAuthenticated(false);
      navigate("/login", { replace: true });
    }
  };

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      setIsAuthenticated(false);
      navigate("/", { replace: true });
      return;
    }
    verifyUser(token);
    const interval = setInterval(() => {
      const currentToken = Cookies.get("token");
      if (currentToken) {
        verifyUser(currentToken);
      }
    }, 240000);
    return () => clearInterval(interval);
  }, [navigate]);
  if (isAuthenticated === null) {
    return <Loader className="h-screen items-center" />;
  }
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/inquiries" element={<Inquiries />} />
      <Route path="/reorder" element={<Reorder />} />
      <Route path="/sellers" element={<ShipDetails />} />
      <Route path="/cancel-order" element={<CancelOrder />} />
      <Route path="/order-update" element={<OrderUpdate />} />
      <Route path="/birthday-sale" element={<BirthdaySale />} />
      <Route path="/winners" element={<Winners />} />
      <Route path="/coupon-code" element={<CouponCode />} />
      <Route path="/couponcard" element={<CouponCard/>}/>
      <Route path="/expert-workshop" element={<ExpertWorkShop/>}/>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default PrivateRoute;
